import * as React from "react"
import { useSignal } from "@preact/signals-react"
import { TextField, Typography, Box } from "@mui/material"
import { ModalSeeker, IconSeeker } from "@ui-seeker/core"

import { favFiltersData } from "./@signals"
import useFavFilterModal from "./@hooks/useFavFilterModal"
import GroupsTable from "./GroupTable"
import FavFiltersIcon from "./FavIcon"


export default function CommonFiltersFavouriteFiltersModal ({ data, ...props }) {

    const { insertFavGroupFilter } = useFavFilterModal()

    const filterName = useSignal('')
    const isOpenFavModal = useSignal(false)

    const handleClick = () => {
        const existingFilter = favFiltersData.value.find(filter => filter.label === filterName.value)
        const existingFilterID = existingFilter ? existingFilter.filterID : null;
        if (filterName.value.length) insertFavGroupFilter(filterName.value, existingFilterID)
    }

    const modalConfig = {
        title:"Favourite Filters Management",
        isOpen: isOpenFavModal.value,
        successText: 'Save',
        controller: () => {
            isOpenFavModal.value = false
            filterName.value = ""
        },
        successProps: {
            onClick: handleClick
        },
        ...props
    }

    return <>
        <FavFiltersIcon isOpenFavModal={isOpenFavModal} dashboardKey={props?.dashboardKey} />
        <ModalSeeker {...modalConfig}>
            <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', mt: 3 }}>
                <TextField 
                    placeholder="Specify a title for the filter"
                    value={filterName.value}
                    onChange={e => filterName.value = e.target.value}
                    sx={{ width: 700 }}
                />
                { !!favFiltersData.value?.length ? <GroupsTable dashboardKey={props?.dashboardKey} /> : <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', mt: 3 }}>
                    <IconSeeker icon='thumbs-down' iconWeight='regular' color='info.light' sx={{ fontSize: '2rem', mb: 2 }} />
                    <Typography variant='p'>No saved filters created</Typography>
                </Box> }
            </Box>
        </ModalSeeker>
    </>
}